module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardImg"
  }, [(_vm.currentCard.mciNumber != undefined) ? _c('img', {
    attrs: {
      "src": _vm.currentCardArt
    }
  }) : _c('div', {
    staticClass: "noArt"
  }, [_vm._v("   \n        " + _vm._s(_vm.currentCard.name) + "\n        "), _c('small', [_vm._v("No Art")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de18e5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardViews/CardArt.vue
// module id = 130
// module chunks = 0